import axios from 'axios';

function logError(error) {
	throw error;
}

const instance = axios.create({
	baseURL: process.env.REACT_APP_API_BACKEND,
});

function pad2(number) {
	return (number < 10 ? '0' : '') + number;
}

class CheckoutService {
	checkout(values) {
		return instance
			.post('/order', { ...values })
			.then(res => res.data)
			.catch(logError);
	}

	getAvailability(initialDate, finalDate, ticketsAmount, experienceId) {
		return instance
			.get(`experience/${experienceId}/availability`,
				{
					params:
						{
							start: initialDate.toISOString(),
							end: finalDate.toISOString(),
							tickets: ticketsAmount,
						},
				})
			.then((res) => {
				for (let i = 0; i < res.data.length; i += 1) {
					for (let j = 0; j < res.data[i].sessions.length; j += 1) {
						res.data[i].sessions[j].hour = pad2(res.data[i].sessions[j].hour);
						res.data[i].sessions[j].minutes = pad2(res.data[i].sessions[j].minutes);
					}
				}
				return res.data;
			})
			.catch(logError);
	}

	getExtrasFromSession(sessionId){
		return instance
			.get(`/session/${sessionId}/extras`)
			.then(res => res.data)
			.catch(logError);
	}

	getStripeToken(amount) {
		return instance
			.post('/payments/intent', { amount })
			.then(res => res.data)
			.catch(logError);
	}
}

export default new CheckoutService();
